<!--  -->
<template>
    <div class='video_c'>
        <div class="video_box">
            <!-- 111111111111111 -->
            <div class="video_box_playrt">
                <!-- <div class="prism-player" id="player-con"></div> -->
                <video controls class="box_playrt_video" :src="data.videoPath"></video>
            </div>
            <div class="video_box_b">
                <div class="video_box_b_left">
                    <h1>{{ data.speechZt }}</h1>
                    <!-- <p class="content" v-html="data.content"></p> -->
                </div>
                <div class="video_box_b_right">
                    <div class="b_right_img">
                        <img :src="data.speechPhoto" alt="">
                    </div>
                    <div class="speaker_box">
                        <p class="speaker">{{ data.speaker }}</p>
                        
                    </div>
                    <p class="b_right_content" v-html="data.content"></p>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: 'video_c',

        data() {
            //这里存放数据
            return {
                videoCode: null,
                data: {},
                code: '',
                playData: {}, //播放data
                player: {
                    id: "player-con",
                    source: "",
                    width: "100%",
                    height: "500px",
                    autoplay: true,
                    isLive: false,
                    rePlay: false,
                    playsinline: true,
                    isVBR: true,
                    preload: true,
                    language: "en-us",
                    controlBarVisibility: "hover",
                    useH5Prism: true
                }
            }
        },
        components: {},

        //方法集合
        methods: {
            meetingvideo() {
                var _this = this;
                _this.$api.meetingvideo({
                    videoCode: _this.videoCode
                }).then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        this.data = res.data
                        // this.player.source = res.data.videoPath
                        this.player.source =
                            "https://vd3.bdstatic.com/mda-pmr3u89k3bm3hx9q/hd/cae_h264/1703559082200493344/mda-pmr3u89k3bm3hx9q.mp4?v_from_s=hkapp-haokan-hbf&auth_key=1703680350-0-0-103917524e5c4ce6185fc398f2d6f1d4&bcevod_channel=searchbox_feed&pd=1&cr=1&cd=0&pt=3&logid=1950959568&vid=3886127048056551371&klogid=1950959568&abtest="


                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    _this.$message.error(error.msg);
                });
            },
        },
        created() {

        },
        mounted() {
            if (this.$route.params.code) {
                this.videoCode = this.$route.params.code
                this.meetingvideo()
            }
        }
    }
</script>
<style scoped>

</style>